// extracted by mini-css-extract-plugin
export default {"container":"Note_container__053Wa","icon":"Note_icon__3f-wj","label":"Note_label__+B3JQ","noteContainer":"Note_noteContainer__bX7gn","paragraph":"Note_paragraph__BJ6ZB"};